export default {"src":"/_next/static/media/cob.f7bb43d5.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};